import { isNone } from '@ember/utils';
import { InAppExpirationType, InAppMessageExpiration } from 'cio/utils/in-app/message-config';
import { inject as service } from '@ember/service';
import MomentService from 'cio/services/moment';
import Helper from '@ember/component/helper';
import { formatNumberAndPluralize } from './format-number-and-pluralize';
import { findRoundUnit, TIMEFRAME_UNITS } from 'cio/utils/round-timeframe-units';
import { EXPIRATION_UNITS } from 'cio/components/action-composer/in-app/config/expiration';

export const DEFAULT_EXPIRATION_LABEL = '30 days after sent';
const DAYS_IN_DEFAULT_EXPIRATION = 30;
const AVAILABLE_UNITS = TIMEFRAME_UNITS.filter((u) => EXPIRATION_UNITS.includes(u.value));

export default class extends Helper {
  @service moment!: MomentService;

  compute([expiration, expiry]: [InAppMessageExpiration, string]) {
    let label = DEFAULT_EXPIRATION_LABEL;
    if (!isNone(expiration?.value)) {
      if (expiration.type === InAppExpirationType.Relative) {
        let unit = findRoundUnit(expiration.value, AVAILABLE_UNITS);
        let unitValue = unit?.value ?? 'day';
        let convertedValue = unit?.seconds ? expiration.value / unit.seconds : DAYS_IN_DEFAULT_EXPIRATION;
        label = `${formatNumberAndPluralize([convertedValue, unitValue])} after sent`;
      } else {
        label = `on ${this.moment.formatTimestamp([expiration.value])}`;
      }
    }
    if (expiration != null && expiration.liquidExpression !== '') {
      return expiry
        ? `${this.moment.formatTimestamp([this.moment.moment(expiry).unix()])} (via liquid)`
        : 'N/A (via liquid)';
    }
    return label;
  }
}
